import { gql } from "@apollo/client";
export const ApproveTransaction = gql `
  mutation ApproveTransaction($input: ApproveTransactionInput!) {
    ApproveTransaction(input: $input)
  }
`;
